const API_BASE = import.meta.env.VITE_API_URL || 'https://api.asistentetradingia.com'

export async function getVapidPublicKey(): Promise<string> {
  const res = await fetch(`${API_BASE}/api/push/vapid-public-key`)
  const data = await res.json()
  return data.public_key
}

export async function subscribeToPush(
  supabaseToken: string
): Promise<boolean> {
  try {
    const sw = await navigator.serviceWorker.ready
    const vapidKey = await getVapidPublicKey()

    const subscription = await sw.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(vapidKey)
    })

    const sub = subscription.toJSON()
    await fetch(`${API_BASE}/api/push/subscribe`, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseToken}`
      },
      body: JSON.stringify({
        endpoint: sub.endpoint,
        p256dh: sub.keys?.p256dh,
        auth: sub.keys?.auth
      })
    })
    return true
  } catch (err) {
    console.error('Push subscribe error:', err)
    return false
  }
}

export async function unsubscribeFromPush(
  supabaseToken: string
): Promise<boolean> {
  try {
    const sw = await navigator.serviceWorker.ready
    const subscription = await sw.pushManager.getSubscription()
    if (!subscription) return true

    await fetch(`${API_BASE}/api/push/unsubscribe`, {
      method: 'DELETE',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${supabaseToken}`
      },
      body: JSON.stringify({ endpoint: subscription.endpoint })
    })

    await subscription.unsubscribe()
    return true
  } catch (err) {
    console.error('Push unsubscribe error:', err)
    return false
  }
}

export function isPushSupported(): boolean {
  return 'serviceWorker' in navigator && 'PushManager' in window
}

export async function getCurrentPermission(): Promise<NotificationPermission> {
  return Notification.permission
}

function urlBase64ToUint8Array(base64String: string): Uint8Array {
  const padding = '='.repeat((4 - base64String.length % 4) % 4)
  const base64 = (base64String + padding)
    .replace(/-/g, '+').replace(/_/g, '/')
  const rawData = window.atob(base64)
  return Uint8Array.from([...rawData].map(c => c.charCodeAt(0)))
}
